import React, { useEffect, useState } from "react";
import SectionTitle02 from "../../components/ConsultancyElements/SectionTitle02";
import RatingService from "../../services/RatingService";
import { Tag } from "antd";
import moment from "moment/moment";

const Testimonials = (props) => {
  const [ratingList, setRatingList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getRatings();
  }, []);

  const getRatings = async () => {
    try {
      setLoading(true);
      const response = await RatingService.getRatingList();
      const publishedRating = response.data.filter(
        (rating) => rating.isPublished === true
      );

      setRatingList(publishedRating || []);
    } catch (error) {
      console.log("error occurring during fetching ratings", error);
    } finally {
      setLoading(false);
    }
  };

  const renderStars = (rating) => {
    return "★".repeat(rating) + "☆".repeat(5 - rating);
  };

  return (
    <section
      className="testimonial-section professional"
      style={{
        backgroundImage: `url(images/background/13.jpg)`,
        padding: "60px 0"
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* LEFT TITLE */}
          <div className="col-xl-4 col-lg-4 col-md-12 mb-4">
            <SectionTitle02
              title="CLIENT TESTIMONIAL"
              header="Trusted by"
              ext="our Clients"
              textColor={props.textColor}
            />
          </div>

          {/* RIGHT COLUMN - HORIZONTAL SCROLL CONTAINER */}
          <div className="col-xl-8 col-lg-8 col-md-12">
            <div
              className="testimonial-scroll-wrapper"
              style={{
                display: "flex",
                overflowX: "auto",
                gap: "20px",
                paddingBottom: "15px",
                scrollbarWidth: "none", 
                msOverflowStyle: "none" }}
            >
              {ratingList.length > 0 ? (
                ratingList.map((item) => (
                  <div
                    className="testimonial-card"
                    key={item.id}
                    style={{
                      flex: "0 0 320px", // Fixed width: won't grow, won't shrink
                      background: '#fff',
                      padding: '20px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div>
                      {/* Rating */}
                      <div className="rating-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <Tag color="blue" style={{ fontSize: '10px' }}>{"Offical"}</Tag>
                        <div className="rating-stars" style={{ color: '#f1c40f', fontSize: '14px' }}>
                          {renderStars(item.rating)}
                        </div>
                      </div>

                      {/* Testimonial Text */}
                      <p className="testimonial-text" style={{
                        fontStyle: 'italic',
                        fontSize: '14px',
                        lineHeight: '1.6',
                        color: '#444',
                        minHeight: '80px' // Keeps cards uniform height
                      }}>
                        “{item?.reviewText}”
                      </p>
                    </div>

                    {/* Client Info */}
                    <div className="client-info" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '15px' }}>
                      <img
                        src="/images/mdisuLogo.png"
                        alt="Client"
                        style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                      />
                      <div>
                        <h6 style={{ margin: 0, fontSize: '14px', fontWeight: 700 }}>{item?.userName}</h6>
                        <span style={{ fontSize: '11px', color: '#9ca3af' }}>{moment(item?.ratingDate).format('MMMM Do YYYY')}</span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ color: '#fff' }}>
                  {loading ? "Loading..." : "No ratings found."}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Inline style for scrollbar appearance */}
      <style>
        {`
          .testimonial-scroll-wrapper::-webkit-scrollbar {
            height: 6px;
          }
          .testimonial-scroll-wrapper::-webkit-scrollbar-thumb {
            background: rgba(255,255,255,0.3);
            border-radius: 10px;
          }
        `}
      </style>
    </section>
  );
};

export default Testimonials;